<template>
	<transition name="fadeIn">
		<router-view></router-view>
	</transition>
</template>

<script>

	export default {
		name: 'RatingLayout',
		computed: {}
	}

</script>
<style lang="scss" scoped>
	.fadeIn-enter-active,
	.fadeIn-leave-active {
		opacity: 1;
		transition: opacity .5s;
	}

	.fadeIn-enter {
		opacity: 0;
	}

	.fadeIn-leave-to {
		opacity: 0;
	}
</style>


// WEBPACK FOOTER //
// RatingLayout.vue?12b5bb9b